import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { formatCurrency } from './adminUtils';

export const AdminSalesTab = ({ salesData, dateRange, setDateRange, language }) => {
  const tr = language === 'tr';
  return (
    <div className="space-y-6" data-testid="admin-sales-tab">
      <div className="flex items-center space-x-4">
        <Label className="text-slate-400">{tr ? 'Tarih Aralığı:' : 'Date Range:'}</Label>
        <Select value={dateRange} onValueChange={setDateRange}>
          <SelectTrigger className="w-40 bg-slate-800 border-slate-700 text-white" data-testid="sales-date-range">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-slate-800 border-slate-700">
            <SelectItem value="7" className="text-white">{tr ? 'Son 7 gün' : 'Last 7 days'}</SelectItem>
            <SelectItem value="30" className="text-white">{tr ? 'Son 30 gün' : 'Last 30 days'}</SelectItem>
            <SelectItem value="90" className="text-white">{tr ? 'Son 90 gün' : 'Last 90 days'}</SelectItem>
            <SelectItem value="365" className="text-white">{tr ? 'Son 1 yıl' : 'Last year'}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="grid md:grid-cols-4 gap-4">
        <Card className="bg-slate-900/50 border-slate-800">
          <CardContent className="py-4">
            <p className="text-xs text-slate-400">{tr ? 'Toplam Satış' : 'Total Sales'}</p>
            <p className="text-2xl font-bold text-white">{salesData?.total_sales || 0}</p>
          </CardContent>
        </Card>
        <Card className="bg-slate-900/50 border-slate-800">
          <CardContent className="py-4">
            <p className="text-xs text-slate-400">{tr ? 'Toplam Gelir (TRY)' : 'Total Revenue (TRY)'}</p>
            <p className="text-2xl font-bold text-emerald-400">{formatCurrency(salesData?.total_revenue_try || 0)}</p>
          </CardContent>
        </Card>
        <Card className="bg-slate-900/50 border-slate-800">
          <CardContent className="py-4">
            <p className="text-xs text-slate-400">{tr ? 'Ort. Sipariş Değeri' : 'Avg Order Value'}</p>
            <p className="text-2xl font-bold text-white">{formatCurrency(salesData?.avg_order_value || 0)}</p>
          </CardContent>
        </Card>
        <Card className="bg-slate-900/50 border-slate-800">
          <CardContent className="py-4">
            <p className="text-xs text-slate-400">{tr ? 'Dönüşüm Oranı' : 'Conversion Rate'}</p>
            <p className="text-2xl font-bold text-blue-400">{salesData?.conversion_rate || 0}%</p>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-slate-900/50 border-slate-800">
        <CardHeader>
          <CardTitle className="text-white">{tr ? 'Pakete Göre Satışlar' : 'Sales by Tier'}</CardTitle>
        </CardHeader>
        <CardContent>
          {(salesData?.by_tier || []).length === 0 ? (
            <p className="text-slate-400 text-sm text-center py-6" data-testid="sales-empty-state">
              {tr ? 'Seçilen dönemde satış bulunmuyor.' : 'No sales in the selected period.'}
            </p>
          ) : (
          <Table>
            <TableHeader>
              <TableRow className="border-slate-700">
                <TableHead className="text-slate-400">{tr ? 'Paket' : 'Tier'}</TableHead>
                <TableHead className="text-slate-400">{tr ? 'Satış Adedi' : 'Sales Count'}</TableHead>
                <TableHead className="text-slate-400">{tr ? 'Gelir (TRY)' : 'Revenue (TRY)'}</TableHead>
                <TableHead className="text-slate-400">{tr ? 'Oran' : 'Share'}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {(salesData?.by_tier || []).map((tier) => (
                <TableRow key={tier.tier} className="border-slate-700">
                  <TableCell className="text-white font-medium capitalize">{tier.tier?.replace('_', ' ')}</TableCell>
                  <TableCell className="text-slate-300">{tier.count}</TableCell>
                  <TableCell className="text-emerald-400">{formatCurrency(tier.revenue)}</TableCell>
                  <TableCell className="text-slate-300">{tier.share}%</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
